document.addEventListener("DOMContentLoaded", () => {
  const SWIPE_THRESHOLD = 50;
  let touchStartY = 0;
  let touchStartX = 0;
  let isVerticalSwipe = false;
  const totalThumbs = window.PRODUCT_IMAGES_SIZE || 1;

  const thumbsSwiper = new Swiper(".swiper-thumbs", {
    slidesPerView: Math.min(5, totalThumbs),
    spaceBetween: 8,
    watchSlidesProgress: true,
    watchOverflow: true,
  });

  const mobileBreakpoint = 768;

  const mainSwiper = new Swiper(".product-swiper-pf-one", {
    autoHeight: window.innerWidth <= mobileBreakpoint,
    spaceBetween: 10,
    navigation: {
      nextEl: ".slider-navigation-pf .swiper-button-next-pf",
      prevEl: ".slider-navigation-pf .swiper-button-prev-pf",
    },
    scrollbar: {
      el: ".slider-navigation-pf .swiper-scrollbar",
      draggable: true,
    },
    thumbs: { swiper: thumbsSwiper },
    watchOverflow: true,
    on: {
      init: function () {
        this.updateAutoHeight();
        this.update();
      },
      slideChange: function () {
        const currentIndex = document.getElementById("currentIndex");
        if (currentIndex) currentIndex.textContent = this.realIndex + 1;
      },
      resize: function () {
        this.params.autoHeight = window.innerWidth <= mobileBreakpoint;
        this.updateAutoHeight();
        this.update();
      },
    },
  });

  window.addEventListener("resize", () => {
    mainSwiper.params.autoHeight = window.innerWidth <= mobileBreakpoint;
    mainSwiper.updateAutoHeight();
    mainSwiper.update();
  });

  const totalSlidesEl = document.getElementById("totalSlides");
  if (totalSlidesEl) totalSlidesEl.textContent = mainSwiper.slides.length;

  let modalSwiperPf;
  const modalPf = document.getElementById("productModalPf");
  const openBtnPf = document.querySelector(".open-modal-btn-pf");
  const closeBtnPf = document.querySelector(
    ".product-modal-pf .close-modal-btn-pf"
  );
  const overlayPf = document.querySelector(
    ".product-modal-pf .modal-overlay-pf"
  );

  const lockBodyScroll = () => {
    document.body.classList.add("modal-open-pf");
    document.documentElement.style.overflow = "hidden";
  };

  const unlockBodyScroll = () => {
    document.body.classList.remove("modal-open-pf");
    document.documentElement.style.overflow = "";
  };

  const openModalPf = () => {
    if (modalPf.parentNode !== document.body)
      document.body.appendChild(modalPf);

    modalPf.classList.add("active");
    modalPf.style.display = "block";
    lockBodyScroll();

    if (!modalSwiperPf) {
      modalSwiperPf = new Swiper(".product-modal-swiper-pf", {
        initialSlide: mainSwiper.realIndex,
        slidesPerView: 1,
        centeredSlides: false,
        resistance: 1000,
        touchReleaseOnEdges: true,
        threshold: 0,
        navigation: {
          nextEl: ".modal-navigation-wrapper-pf .product-modal-swiper-next-pf",
          prevEl: ".modal-navigation-wrapper-pf .product-modal-swiper-prev-pf",
        },
        on: {
          touchEnd: (swiper, event) => {
            if (swiper.touchEventsData.velocity > 0.3) {
              swiper.touchEventsData.startX > swiper.touchEventsData.currentX
                ? swiper.slideNext()
                : swiper.slidePrev();
            }
          },
        },
      });
    } else {
      modalSwiperPf.slideTo(mainSwiper.realIndex, 0);
      modalSwiperPf.update();
    }
  };

  const closeModalPf = () => {
    modalPf.classList.remove("active");
    modalPf.style.display = "none";
    unlockBodyScroll();
  };

  if (openBtnPf) openBtnPf.addEventListener("click", openModalPf);
  if (closeBtnPf) closeBtnPf.addEventListener("click", closeModalPf);
  if (overlayPf) overlayPf.addEventListener("click", closeModalPf);

  const swiperContainer = document.querySelector(".product-swiper-pf-one");
  swiperContainer?.addEventListener("click", (e) => {
    if (e.target.tagName === "IMG" && e.target.closest(".swiper-slide")) {
      openModalPf();
    }
  });

  modalPf.addEventListener(
    "touchstart",
    (e) => {
      touchStartY = e.touches[0].clientY;
      touchStartX = e.touches[0].clientX;
      isVerticalSwipe = false;
    },
    { passive: true }
  );

  modalPf.addEventListener(
    "touchmove",
    (e) => {
      const deltaY = e.touches[0].clientY - touchStartY;
      const deltaX = e.touches[0].clientX - touchStartX;
      isVerticalSwipe = Math.abs(deltaY) > Math.abs(deltaX);
      if (isVerticalSwipe && Math.abs(deltaY) > 10) e.preventDefault();
    },
    { passive: false }
  );

  modalPf.addEventListener("touchend", (e) => {
    const deltaY = e.changedTouches[0].clientY - touchStartY;
    if (isVerticalSwipe && Math.abs(deltaY) > SWIPE_THRESHOLD) closeModalPf();
    touchStartY = touchStartX = isVerticalSwipe = 0;
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modalPf.classList.contains("active")) {
      closeModalPf();
    }
  });
});
